<div class="min-h-screen bg-gray-50 p-6">
  <!-- Header -->
  <div class="mb-8">
    <h1 class="text-3xl font-semibold text-gray-900 mb-6">{{ t('stock.tabs.statistics') }}</h1>


    <!-- Stats Cards -->
    <div class="grid grid-cols-4 gap-4 mb-8">
      <div class="bg-white rounded-lg p-4 shadow-sm">
        <div class="text-sm text-gray-600 mb-1">{{ t('stock.stats.materialsUsed') }}</div>
        <div class="text-2xl font-bold text-gray-900">{{ statsData.materialsUsed }}</div>
      </div>
      <div class="bg-white rounded-lg p-4 shadow-sm">
        <div class="text-sm text-gray-600 mb-1">{{ t('stock.stats.ordersPlaced') }}</div>
        <div class="text-2xl font-bold text-gray-900">{{ statsData.ordersPlaced }}</div>
      </div>
      <div class="bg-white rounded-lg p-4 shadow-sm">
        <div class="text-sm text-gray-600 mb-1">{{ t('stock.stats.deliveriesReceived') }}</div>
        <div class="text-2xl font-bold text-gray-900">{{ statsData.deliveriesReceived }}</div>
      </div>
      <div class="bg-white rounded-lg p-4 shadow-sm">
        <div class="text-sm text-gray-600 mb-1">{{ t('stock.stats.alertsTriggered') }}</div>
        <div class="text-2xl font-bold text-red-600">{{ statsData.alertsTriggered }}</div>
      </div>
    </div>

    <!-- Charts Section -->
    <div class="grid grid-cols-1 gap-8">
      <!-- Left Section - Pie Chart -->
      <div class="bg-white rounded-lg p-6 shadow-sm">
        <h3 class="text-lg font-semibold text-gray-900 mb-6">{{ t('stock.stats.categoryDistribution') }}</h3>

        <div class="flex items-center gap-8">
          <!-- Chart Canvas Container -->
          <div class="flex-shrink-0 relative">
            <div class="w-64 h-64 flex items-center justify-center">
              <canvas #categoryChart class="max-w-full max-h-full"></canvas>
            </div>
          </div>

          <!-- Legend -->
          <div class="flex-1 space-y-4">
            <div class="flex items-center justify-between py-2 border-b border-gray-100 last:border-b-0"
              *ngFor="let item of categoryData; ">
              <div class="flex items-center gap-3">
                <div class="w-4 h-4 rounded-full shadow-sm" [style.background-color]="item.color"></div>
                <span class="text-sm font-medium text-gray-700 capitalize">{{ item.label }}</span>
              </div>
              <span class="text-sm font-bold text-gray-900">{{ item.percentage }}%</span>
            </div>

            <!-- Message si aucune donnée -->
            <div *ngIf="categoryData.length === 0" class="text-center text-gray-500 py-8">
              <p class="text-sm">{{ t('common.noData') }}</p>
            </div>
          </div>
        </div>

        <!-- Informations supplémentaires (optionnel) -->
        <div class="mt-6 pt-4 border-t border-gray-100" *ngIf="categoryData.length > 0">
          <p class="text-xs text-gray-500">
            {{ t('stock.stats.totalCategories') }} {{ categoryData.length }}
          </p>
        </div>
      </div>


    </div>
  </div>

  <!-- le ts  -->